<div class="dialog">
  <mat-dialog-content class="dialog-content">
    <p [innerHTML]="data.message"></p>
  </mat-dialog-content>
  <mat-dialog-actions *ngIf="data.hasButton">
    <button mat-button mat-dialog-close class="btn btn-lg btn-greengo">{{ data.buttonText ? data.buttonText : 'OK' }}</button>
  </mat-dialog-actions>
</div>